import { useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { BackdropDialog } from '../../../../components/shared/backdrop/BackdropDialog';
import { Page } from '../../../../components/shared/page/Page';
import {
  AttemptMode,
  useResumeMultipleChoiceAssessmentAttempt,
} from '../../../../features/assessments/api/useMultipleChoiceAssessments';
import { MultipleChoiceAssessmentAttempt } from '../../../../features/assessments/components/multiple-choice-assessment-attempt/MultipleChoiceAssessmentAttempt';
import { MultipleChoicePausedAssessmentAttemptList } from '../../../../features/assessments/components/multiple-choice-paused-assessment-attempt-list/MultipleChoicePausedAssessmentAttemptList';

function MultipleChoicePausedAssessmentAttemptListPage() {
  const { subjectId } = useParams();
  const navigate = useNavigate();

  const [selectedAttempt, setSelectedAttempt] = useState<{
    id: string;
    mode?: AttemptMode;
  }>();

  const { mutateAsync: resumeMultipleChoiceAssessmentAttempt } =
    useResumeMultipleChoiceAssessmentAttempt();

  return (
    <Page title="Simulacros en progreso">
      <MultipleChoicePausedAssessmentAttemptList
        subjectId={subjectId!}
        onSelected={(assessmentAttemptId: string, mode?: AttemptMode) =>
          setSelectedAttempt({ id: assessmentAttemptId, mode })
        }
      />
      <BackdropDialog open={selectedAttempt !== undefined}>
        <MultipleChoiceAssessmentAttempt
          // The attempt was created with a mode already, so resuming carries it on
          // instead of asking again. Only an attempt from an API that predates the
          // mode arrives without one, and that one still asks.
          mode={selectedAttempt?.mode}
          onStart={() =>
            resumeMultipleChoiceAssessmentAttempt({
              subjectId: subjectId!,
              assessmentAttemptId: selectedAttempt!.id,
            })
          }
          onFinish={(attempt) => {
            setSelectedAttempt(undefined);
            navigate(
              `/materia/${subjectId}/simulacros/mc/resultados/${attempt.id}`,
            );
          }}
          onClose={() => setSelectedAttempt(undefined)}
        />
      </BackdropDialog>
    </Page>
  );
}

export { MultipleChoicePausedAssessmentAttemptListPage };
